module.exports = __webpack_public_path__ + "img/star-blue.12735427.svg";